<template>
  <div class="container mt-3">
    <div class="mt-3">
      <h3 class="title mb-3">플랫폼 관리</h3>
    </div>

    <div class="search-container">
      <div class="search-box">
        <b-row>
          <b-col cols="6">
            <b-row>
              <b-col cols="12" class="label bold">Company </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <multiselect
                  v-model="selectValue"
                  :options="options"
                  placeholder="회사명을 입력해주세요."
                  label="kname"
                  track-by="kname"
                  :loading="isLoading"
                  @search-change="funcListApi"
                  @select="funcSelectItem">
                  <template #clear>
                    <span class="vue-select-delete" v-if="selectValue" @mousedown.prevent.stop="valueClear">삭제</span>
                  </template>
                </multiselect>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col cols="12" class="label bold">기간</b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-row>
                  <b-col cols="6">
                    <Datepicker
                      v-model="searchObject.datePickStDt"
                      :enableTimePicker="false"
                      :format="funcFormat"
                      @update:modelValue="funcHandleStartDate"
                      placeholder="기간을 선택해주세요" />
                  </b-col>
                  <b-col cols="6">
                    <Datepicker
                      v-model="searchObject.datePickEndDt"
                      :enableTimePicker="false"
                      :format="funcFormat"
                      @update:modelValue="funcHandleEndDate"
                      placeholder="기간을 선택해주세요" />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-row>
              <b-col cols="12" class="label bold">본부/팀 </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-select class="search-selectbox" :options="compTeamList" v-model="searchObject.teamIdx"></b-form-select>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col cols="12" class="label bold">HQ 매니저 </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-select class="search-selectbox" :options="compManagerList" v-model="searchObject.hqIdx"></b-form-select>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-row>
              <b-col cols="12" class="label bold">플랫폼명 </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-input class="search-input" placeholder="플랫폼명을 입력해주세요" v-model="searchObject.platformName" @keyup.enter="funcSearch"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <div class="txt-right mt-3">
        <b-button variant="primary" class="search-button" @click="funcSearch">검색</b-button>
        <b-button variant="primary" class="search-button ms-2" @click="funcMovePage('/platform/platformManage')">플랫폼 생성</b-button>
      </div>

      <p class="mt-3 bold">※ 플랫폼을 비활성화 하면 해당 통합수강신청 플랫폼은 캐럿글로벌 홈페이지로 연결됩니다.</p>
      <div class="mt-3 carrot-box p-3">
        <Table ref="table1" :id="`platformListTable`" :isCheckBox="false" :tabledata="tableData" :loading="tableLoading">
          <!--########################### Body Custom ###########################-->
          <template #BodyplatformName="{ row }">
            <span class="hyperlink text-ellipsis" @click="funcMovePage(`/platform/platformManage?idx=${row.idx}`)">{{ row.platformName }}</span>
          </template>
          <template #BodyviewPlatform="{ row }">
            <span class="hyperlink" @click="newPage(row.code)">view</span>
          </template>
          <template #Bodyinquiry="{ row }">
            <span class="hyperlink" @click="funcMovePage(`/company/companyInquiry/list?sugangIdx=${row.idx}&platformName=${row.platformName}&companyName=${row.companyName}`)">view</span>
          </template>
          <template #BodyisClose="{ row }">
            <button type="button" class="btn btn-secondary" v-if="row.isClose === 'Y'" @click="funCloseYn(row)">비활성화</button>
            <button type="button" class="btn btn-primary" v-else-if="row.isClose === 'N'" @click="funCloseYn(row)">활성화</button>
          </template>
        </Table>

        <div class="mt-3" v-show="!tableLoading">
          <Paging :totaldata="pagingTotal" :pagingdata="searchObject.pageSize" :pagingrange="5" :setPage="setPage" @onPagingEvent="onMovePageing"></Paging>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from '@vue/reactivity';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { computed, onActivated, onMounted } from '@vue/runtime-core';
import _ from 'lodash';
import { companyListApi, sugangListApi, closeSugangApi } from '@/api/integrateapi/index';
import { userSite } from '@/plugins/axios/apiUrl';
export default {
  name: 'managePaltform',
  setup() {
    //data
    const router = useRouter();
    //검색 그룹
    const searchObject = reactive({
      datePickStDt: new Date(),
      datePickEndDt: new Date(),
      startDate: '',
      endDate: '',
      teamIdx: '',
      hqIdx: '',
      companyIdx: '',
      platformName: '',
      pageNum: 1,
      pageSize: 50,
    });
    const pagingTotal = ref(1);
    const setPage = ref(1);
    //테이블 데이터
    const tableData = reactive({
      head: [
        {
          headkey: 'rowNum',
          colname: 'No',
        },
        {
          headkey: 'companyName',
          colname: 'company',
        },
        {
          headkey: 'platformName',
          colname: '플랫폼명',
        },
        {
          headkey: 'periodDate',
          colname: '기간',
        },
        {
          headkey: 'status',
          colname: '상태',
        },
        {
          headkey: 'courseName',
          colname: '과정',
        },
        {
          headkey: 'hqName',
          colname: '생성 HQ',
        },
        {
          headkey: 'viewPlatform',
          colname: '플랫폼보기',
        },
        {
          headkey: 'inquiry',
          colname: '공지사항',
        },
        {
          headkey: 'isClose',
          colname: '활성/비활성',
        },
      ],
      body: [],
    });
    let options = reactive([]);

    const selectValue = ref(null);
    const isLoading = ref(false);
    const tableLoading = ref(false);

    //store
    const store = useStore();

    //func
    const funcFormat = date => {
      const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
      const year = date.getFullYear();

      return `${year}-${month}-${day}`;
    };

    //회사 검색 조회
    const funcListApi = query => {
      isLoading.value = true;
      companyListApi(query)
        .then(result => {
          options.length = 0;
          const { data: respData } = result.data;
          const { list } = respData;

          list.forEach(item => {
            options.push(item);
          });
        })
        .catch(err => {
          console.error('errror : ', err);
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    const funcMovePage = path => {
      router.push(path);
    };

    const newPage = code => {
      //  alert('준비중입니다.');
      window.open(`${userSite}/settings/${code}`, '_blank');
    };

    const funcHandleStartDate = date => {
      if (date) {
        searchObject.startDate = dateToString(date);
      } else {
        searchObject.startDate = '';
      }
    };

    const funcHandleEndDate = date => {
      if (date) {
        searchObject.endDate = dateToString(date);
      } else {
        searchObject.endDate = '';
      }
    };

    const funcSearch = () => {
      searchObject.pageNum = 1;
      setPage.value = 1;
      apiCompanyList();
    };

    const valueClear = () => {
      selectValue.value = null;
      searchObject.companyIdx = null;
    };

    const funcSelectItem = item => {
      const { idx } = item;
      searchObject.companyIdx = idx;
    };

    const funCloseYn = item => {
      let closeStr = `비활성화 하시면 해당과정이 폐쇄 됩니다.\n폐쇄 하시겠습니까?`;
      let openStr = `활성화 하시면 해당과정이 활성화 됩니다.\n활성화 하시겠습니까?`;
      let str = item.isClose === 'Y' ? openStr : closeStr;
      if (confirm(str)) {
        closeSugangApi({
          sugangIdx: item.idx,
          isClose: item.isClose === 'Y' ? 'N' : 'Y',
        })
          .then(resp => {
            const { success } = resp.data;
            let successStr = item.isClose === 'Y' ? '활성화' : '폐쇄';
            if (success) {
              alert(`${successStr} 에 성공하였습니다.`);
              apiCompanyList();
            } else {
              alert(`${successStr} 에 실패하였습니다.`);
            }
          })
          .catch(error => {
            if (error.response) {
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
              console.log(error.request);
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
              console.log('Error', error.message);
            }
            console.log(error.config);
          })
          .finally(() => {});
      }
    };

    const onMovePageing = pagenumber => {
      searchObject.pageNum = pagenumber;
      setPage.value = pagenumber;

      apiCompanyList();
    };

    const apiCompanyList = () => {
      tableLoading.value = true;
      sugangListApi(searchObject)
        .then(res => {
          const { success, data: respData } = res.data;
          if (success) {
            const { list, total } = respData;
            pagingTotal.value = total;
            list.forEach(item => {
              item['periodDate'] = `${item.startDate} - ${item.endDate}`;
            });
            tableData.body = list;
          } else {
            tableData.body = 0;
            pagingTotal.value = 1;
          }
        })
        .catch(error => {
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          tableLoading.value = false;
        });
    };

    //computed
    const compManagerList = computed(() => {
      const cloneManagerList = _.cloneDeep(store.getters.getManagerList);
      cloneManagerList.unshift({
        value: '',
        text: '-전체-',
      });

      return cloneManagerList;
    });

    const compTeamList = computed(() => {
      const cloneTeamList = _.cloneDeep(store.getters.getTeamList);
      cloneTeamList.unshift({
        value: '',
        text: '-전체-',
      });
      return cloneTeamList;
    });

    const dateToString = valDate => {
      let str = '';
      const year = valDate.getFullYear();
      const month = valDate.getMonth() + 1 > 9 ? valDate.getMonth() + 1 : `0${valDate.getMonth() + 1}`;
      const date = valDate.getDate() > 9 ? valDate.getDate() : `0${valDate.getDate()}`;

      str = `${year}-${month}-${date}`;
      return str;
    };

    onMounted(() => {
      // 종료일자는 현재일자 + 7
      searchObject.datePickEndDt = new Date(searchObject.datePickStDt.getFullYear(), searchObject.datePickStDt.getMonth(), searchObject.datePickStDt.getDate() + 7);

      searchObject.stDate = dateToString(searchObject.datePickStDt);
      searchObject.endDate = dateToString(searchObject.datePickEndDt);

      //수강신청 리스트 api 호출
      apiCompanyList();
    });

    onActivated(() => {
      // 종료일자는 현재일자 + 7
      searchObject.datePickEndDt = new Date(searchObject.datePickStDt.getFullYear(), searchObject.datePickStDt.getMonth(), searchObject.datePickStDt.getDate() + 7);

      searchObject.stDate = dateToString(searchObject.datePickStDt);
      searchObject.endDate = dateToString(searchObject.datePickEndDt);

      //수강신청 리스트 api 호출
      apiCompanyList();
    });

    return {
      searchObject,
      selectValue,
      options,
      isLoading,
      tableLoading,
      funcFormat,
      funcListApi,
      valueClear,
      compTeamList,
      compManagerList,
      pagingTotal,
      setPage,
      tableData,
      onMovePageing,
      funcMovePage,
      funcSelectItem,
      funcHandleStartDate,
      funcHandleEndDate,
      funcSearch,
      funCloseYn,
      newPage,
    };
  },
};
</script>

<style lang="scss">
#platformListTable {
  #companyName {
    width: 200px;
  }

  #platformName {
    width: 150px;

    .text-ellipsis {
      width: 265px;
      text-align: left;

      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
